// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./telemetry-modal-header.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

h2 {
  font-size: 1.5rem;
  font-weight: bold;
}

p {
  font-size: 1rem;
  line-height: 1.5em;
}

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

/* from scratch-www */

.telemetry-modal_modal-overlay_eJjcx {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 510;
  background-color: var(--ui-modal-overlay);
}

.telemetry-modal_modal-content_vTkMr {
  margin: 100px auto;
  outline: none;
  border: 0.25rem solid var(--ui-white-transparent);
  padding: 0;
  border-radius: 0.5rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  width: 640px;

  color: var(--text-primary);
  overflow: hidden;
}

.telemetry-modal_illustration_ZM4Wu {
  width: 100%;
  height: 123px;
  background-color: var(--looks-secondary);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.telemetry-modal_body_Xq3Cm {
  background: var(--ui-white);
  padding: 1.5rem 2.25rem;
}

.telemetry-modal_privacy-policy-link_UYBzF {
  color: var(--looks-secondary);
  text-decoration: none;
}

/* stack the radio buttons vertically, not horizontally */

.telemetry-modal_radio-buttons_WNQTW label {
  display: block;
  margin: 0.5rem;
  transition: all 0.125s ease;
  background-color: hsla(0, 0%, 95%, 1);
  border-radius: 0.5rem;
  margin: 0 auto 0.375rem;
  align-items: center;
  padding: 1rem 0;
  vertical-align: middle;
}

.telemetry-modal_radio-buttons_WNQTW label:hover {
  background-color: hsla(215, 100%, 65%, 0.1);
}

.telemetry-modal_radio-buttons_WNQTW label.telemetry-modal_label-selected_osqYm,
.telemetry-modal_radio-buttons_WNQTW label.telemetry-modal_label-selected_osqYm:hover {
  background-color: hsla(215, 100%, 65%, 0.25);
}

.telemetry-modal_radio-buttons_WNQTW input[type='radio'] {
  margin: -1px 0.75rem 1px;
  border: 1px solid hsla(0, 0%, 0%, 0.1);
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--ui-white);
  vertical-align: middle;
}

.telemetry-modal_radio-buttons_WNQTW input[type='radio']:checked,
.telemetry-modal_radio-buttons_WNQTW input[type='radio']:focus {
  box-shadow: 0 0 0 2px hsla(215, 100%, 65%, 0.25);
  outline: none;
}

.telemetry-modal_radio-buttons_WNQTW input[type='radio']:checked {
  transition: all 0.25s ease;
  background-color: var(--ui-white);
  border: 1px solid var(--looks-secondary);
}

.telemetry-modal_radio-buttons_WNQTW input[type='radio']:checked::after {
  display: block;
  margin: 0.125rem;
  border-radius: 50%;
  background-color: var(--looks-secondary);
  width: 0.625rem;
  height: 0.625rem;
  content: '';
}

/* Confirmation buttons at the bottom of the modal */

.telemetry-modal_button-row_pc6a2 {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: baseline;

  margin: 1.5rem 0;
  font-weight: bolder;
}

@keyframes telemetry-modal_fade-out_xVg3i {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.telemetry-modal_setting-was-updated_dQbap {
  animation: telemetry-modal_fade-out_xVg3i 3s ease-out;
  color: var(--extensions-primary);
}

.telemetry-modal_button-row_pc6a2 button {
  border: 1px solid var(--looks-secondary);
  border-radius: 0.25rem;
  padding: 0.5rem 1.5rem;
  color: white;
  background: var(--looks-secondary);
  font-weight: bold;
  font-size: 0.875rem;
  cursor: pointer;
}

.telemetry-modal_button-row_pc6a2 button:hover {
  background: var(--extensions-primary);
  box-shadow: 0 0 0 6px var(--looks-transparent);
}

.telemetry-modal_button-row_pc6a2 button:disabled {
  background: var(--text-primary);
  border-color: var(--ui-black-transparent);
  box-shadow: none;
  opacity: 0.25;
}

@media screen and (max-height: 660px) {
  .telemetry-modal_modal-content_vTkMr {
    margin: 5vh auto;
    width: 90%;
  }
}

@media screen and (max-height: 540px) {
  .telemetry-modal_illustration_ZM4Wu {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/telemetry-modal/telemetry-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D,qBAAqB;;AAErB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iDAAiD;EACjD,UAAU;EACV,qBAAqB;EACrB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,YAAY;;EAEZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,yDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,yDAAyD;;AAEzD;EACE,cAAc;EACd,cAAc;EACd,2BAA2B;EAC3B,qCAAqC;EACrC,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;EAEE,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,qBAAqB;;EAErB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qDAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\nbody {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\nh2 {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\np {\n  font-size: 1rem;\n  line-height: 1.5em;\n}\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n/* from scratch-www */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 510;\n  background-color: var(--ui-modal-overlay);\n}\n\n.modal-content {\n  margin: 100px auto;\n  outline: none;\n  border: 0.25rem solid var(--ui-white-transparent);\n  padding: 0;\n  border-radius: 0.5rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 640px;\n\n  color: var(--text-primary);\n  overflow: hidden;\n}\n\n.illustration {\n  width: 100%;\n  height: 123px;\n  background-color: var(--looks-secondary);\n  background-image: url('./telemetry-modal-header.png');\n  background-size: cover;\n}\n\n.body {\n  background: var(--ui-white);\n  padding: 1.5rem 2.25rem;\n}\n\n.privacy-policy-link {\n  color: var(--looks-secondary);\n  text-decoration: none;\n}\n\n/* stack the radio buttons vertically, not horizontally */\n\n.radio-buttons label {\n  display: block;\n  margin: 0.5rem;\n  transition: all 0.125s ease;\n  background-color: hsla(0, 0%, 95%, 1);\n  border-radius: 0.5rem;\n  margin: 0 auto 0.375rem;\n  align-items: center;\n  padding: 1rem 0;\n  vertical-align: middle;\n}\n\n.radio-buttons label:hover {\n  background-color: hsla(215, 100%, 65%, 0.1);\n}\n\n.radio-buttons label.label-selected,\n.radio-buttons label.label-selected:hover {\n  background-color: hsla(215, 100%, 65%, 0.25);\n}\n\n.radio-buttons input[type='radio'] {\n  margin: -1px 0.75rem 1px;\n  border: 1px solid hsla(0, 0%, 0%, 0.1);\n  border-radius: 50%;\n  width: 1rem;\n  height: 1rem;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: var(--ui-white);\n  vertical-align: middle;\n}\n\n.radio-buttons input[type='radio']:checked,\n.radio-buttons input[type='radio']:focus {\n  box-shadow: 0 0 0 2px hsla(215, 100%, 65%, 0.25);\n  outline: none;\n}\n\n.radio-buttons input[type='radio']:checked {\n  transition: all 0.25s ease;\n  background-color: var(--ui-white);\n  border: 1px solid var(--looks-secondary);\n}\n\n.radio-buttons input[type='radio']:checked::after {\n  display: block;\n  margin: 0.125rem;\n  border-radius: 50%;\n  background-color: var(--looks-secondary);\n  width: 0.625rem;\n  height: 0.625rem;\n  content: '';\n}\n\n/* Confirmation buttons at the bottom of the modal */\n\n.button-row {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: baseline;\n\n  margin: 1.5rem 0;\n  font-weight: bolder;\n}\n\n@keyframes fade-out {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.setting-was-updated {\n  animation: fade-out 3s ease-out;\n  color: var(--extensions-primary);\n}\n\n.button-row button {\n  border: 1px solid var(--looks-secondary);\n  border-radius: 0.25rem;\n  padding: 0.5rem 1.5rem;\n  color: white;\n  background: var(--looks-secondary);\n  font-weight: bold;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.button-row button:hover {\n  background: var(--extensions-primary);\n  box-shadow: 0 0 0 6px var(--looks-transparent);\n}\n\n.button-row button:disabled {\n  background: var(--text-primary);\n  border-color: var(--ui-black-transparent);\n  box-shadow: none;\n  opacity: 0.25;\n}\n\n@media screen and (max-height: 660px) {\n  .modal-content {\n    margin: 5vh auto;\n    width: 90%;\n  }\n}\n\n@media screen and (max-height: 540px) {\n  .illustration {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-overlay": `telemetry-modal_modal-overlay_eJjcx`,
	"modalOverlay": `telemetry-modal_modal-overlay_eJjcx`,
	"modal-content": `telemetry-modal_modal-content_vTkMr`,
	"modalContent": `telemetry-modal_modal-content_vTkMr`,
	"illustration": `telemetry-modal_illustration_ZM4Wu`,
	"body": `telemetry-modal_body_Xq3Cm`,
	"privacy-policy-link": `telemetry-modal_privacy-policy-link_UYBzF`,
	"privacyPolicyLink": `telemetry-modal_privacy-policy-link_UYBzF`,
	"radio-buttons": `telemetry-modal_radio-buttons_WNQTW`,
	"radioButtons": `telemetry-modal_radio-buttons_WNQTW`,
	"label-selected": `telemetry-modal_label-selected_osqYm`,
	"labelSelected": `telemetry-modal_label-selected_osqYm`,
	"button-row": `telemetry-modal_button-row_pc6a2`,
	"buttonRow": `telemetry-modal_button-row_pc6a2`,
	"setting-was-updated": `telemetry-modal_setting-was-updated_dQbap`,
	"settingWasUpdated": `telemetry-modal_setting-was-updated_dQbap`,
	"fade-out": `telemetry-modal_fade-out_xVg3i`,
	"fadeOut": `telemetry-modal_fade-out_xVg3i`
};
export default ___CSS_LOADER_EXPORT___;
